import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import { formatPercent } from "@/utils/format";

interface ContentCitationTableProps {
  className?: string;
  style?: React.CSSProperties;
  rows?: any[];
}

const ContentCitationTable: React.FC<ContentCitationTableProps> = ({
  className,
  style,
  rows,
}) => {
  const { t } = useTranslation();
  const [contentRows, setContentRows] = useState<any[]>(rows || []);
  const [visibleCount, setVisibleCount] = useState<number>(10);

  // 不再挂载时自拉取，完全由父组件传入 rows 控制
  useEffect(() => {
    setContentRows(rows || []);
    // 添加调试日志，查看传入的数据结构
    if (rows && rows.length > 0) {
      console.log("ContentCitationTable received rows:", rows[0]);
    }
  }, [rows]);

  return (
    <div className={className} style={style}>
      <div style={{ marginBottom: 12 }}>
        <span
          style={{
            whiteSpace: "nowrap",
            color: "rgb(148, 163, 184)",
            fontSize: 16,
          }}
        >
          {t("common.charts.citation_content_title")}
        </span>
      </div>
      <div
        style={{ border: "1px solid #e5e7eb", borderRadius: 6 }}
        className="content-yyt-table"
      >
        <Table
          rowKey="key"
          size="small"
          pagination={false}
          tableLayout="auto"
          style={{ width: "100%", borderCollapse: "collapse" }}
          dataSource={contentRows.slice(0, visibleCount)}
          components={{
            header: {
              wrapper: (props: any) => <thead {...props} />,
            },
            body: {
              wrapper: (props: any) => <tbody {...props} />,
            },
          }}
          columns={[
            {
              title: t("common.charts.citation_content_title_header"),
              dataIndex: "media",
              key: "media",
              onHeaderCell: () => ({
                style: {
                  whiteSpace: "nowrap",
                  fontWeight: 700,
                  textAlign: "left",
                },
              }),
              render: (text: string, record: any) => {
                // 如果有url字段且非空，则渲染为可点击链接
                if (record.url) {
                  return (
                    <a
                      href={record.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#21C4B8",
                        fontWeight: 400,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        maxWidth: "40vw",
                        wordBreak: "break-word",
                        textDecoration: "none",
                        textAlign: "left",
                      }}
                    >
                      {text}
                    </a>
                  );
                }
                // 否则渲染为普通文本
                return (
                  <span
                    style={{
                      color: "#21C4B8",
                      fontWeight: 400,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      maxWidth: "40vw",
                      wordBreak: "break-word",
                      textAlign: "left",
                    }}
                  >
                    {text}
                  </span>
                );
              },
            },
            {
              title: t("common.charts.citation_content_source"),
              dataIndex: "domain",
              key: "domain",
              onHeaderCell: () => ({
                style: {
                  whiteSpace: "nowrap",
                  fontWeight: 700,
                  textAlign: "center",
                },
              }),
              render: (text: string) => (
                <span style={{ color: "#334155" }}>{text}</span>
              ),
            },
            {
              title: t("common.charts.citation_ratio_header"),
              dataIndex: "ratio",
              key: "ratio",
              onHeaderCell: () => ({
                style: {
                  whiteSpace: "nowrap",
                  fontWeight: 700,
                  textAlign: "center",
                },
              }),
              render: (text: string) => (
                <span style={{ color: "#334155" }}>{text}</span>
              ),
            },
          ]}
          onRow={(record, index) => {
            return {
              style: {
                backgroundColor:
                  index !== undefined && index % 2 === 1
                    ? "#f8fafc"
                    : "#ffffff",
                backgroundRepeat: "no-repeat",
                textAlign: "center",
                borderBottom: "1px solid rgb(243, 244, 246)",
              },
            };
          }}
        />
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8, gap: 8 }}>
        <span style={{fontSize: 12 }}>共 {contentRows.length} 条，已显示 {Math.min(visibleCount, contentRows.length)} 条</span>
        {visibleCount <= contentRows.length && (
          <Button 
            size="small" 
            type="link" 
            style={{padding: 0 }}
            onClick={() => setVisibleCount(Math.min(visibleCount + 10, contentRows.length))}
          >
            展开更多
          </Button>
        )}
        {visibleCount > 10 && (
          <Button 
            size="small" 
            type="link" 
            style={{ padding: 0 }}
            onClick={() => setVisibleCount(10)}
          >
            收起
          </Button>
        )}
      </div> */}
    </div>
  );
};

export default ContentCitationTable;
